module.exports = __webpack_public_path__ + "img/丽江4_1.39468151.jpg";